import { Button, Dialog, Separator, Text } from '@betterment/samba-react';

type RecurringTransactionsCardViewProps = {
  shortDisclosure: string;
  longDisclosure: string;
};

export const RecurringTransactionsDisclosure = ({
  shortDisclosure,
  longDisclosure,
}: RecurringTransactionsCardViewProps) => {
  return (
    <>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Text as="p" variant="text25" color="text.weak" css={{ margin: 'space.300' }}>
        {shortDisclosure}{' '}
        <Dialog overlay="default">
          <Dialog.Trigger data-samba-component={true} asChild={true}>
            <Button variant="textSecondary">See disclosure</Button>
          </Dialog.Trigger>
          <Dialog.Content
            css={{
              padding: 'space.400',
              width: '100%',
              maxWidth: 'container.xlarge',
              maxHeight: '80vh',
              overflow: 'auto',
            }}
          >
            <Text dangerouslySetInnerHTML={{ __html: longDisclosure }} />
          </Dialog.Content>
        </Dialog>
        .
      </Text>
    </>
  );
};
